type Props = {
  color?: string;
  className?: string;
};

export function HockeyGoalSymbol({ color = "currentColor", className }: Props) {
  return (
    <g className={className} aria-hidden="true">
      <path
        className="goal-back-frame"
        d="M14-27H-2C-14-27-20-17-20 0S-14 27-2 27H14"
        fill="none"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="goal-front-post"
        d="M14-28V28"
        fill="none"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <g
        className="goal-netting"
        fill="none"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        opacity=".72"
      >
        <path d="M-10-21H14M-16-14H14M-19-7H14M-20 0H14M-19 7H14M-16 14H14M-10 21H14" />
        <path d="M-14-17V17M-8-24V24M-2-27V27M4-27V27M10-27V27" />
      </g>
    </g>
  );
}
